<template>
  <el-config-provider :locale="zhCn">
    <div
      v-show="isRouting"
      class="route-progress bg-green-500"
      :style="{ width: progress + '%' }"
    ></div>
    <NuxtLayout>
      <NuxtPage :transition="{ name: 'page', mode: 'out-in' }" />
    </NuxtLayout>
  </el-config-provider>
</template>
<script setup lang="ts">
import "element-plus/theme-chalk/dark/css-vars.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { ref, onMounted, onUnmounted } from "vue";
const router = useRouter();
const isRouting = ref(false);
const progress = ref(0);
let timer: any = null;

const startProgress = () => {
  isRouting.value = true;
  progress.value = 0;
  if (timer) clearInterval(timer);
  timer = setInterval(() => {
    progress.value = Math.min(progress.value + Math.random() * 20, 90);
  }, 200);
};

const finishProgress = () => {
  if (timer) clearInterval(timer);
  progress.value = 100;
  setTimeout(() => {
    isRouting.value = false;
    progress.value = 0;
  }, 200);
};

onMounted(() => {
  router.beforeEach((_to, _from, next) => {
    startProgress();
    next();
  });
  router.afterEach(() => {
    finishProgress();
  });
});

onUnmounted(() => {
  if (timer) clearInterval(timer);
});
</script>
<style>
@import "~/assets/css/main.css";
</style>
